module.exports = __webpack_public_path__ + "static/media/paraiso.36889147.jpg";